var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgEye = function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.8047 18.9922C33.1015 11.1914 27.5039 7.26562 20 7.26562C12.4922 7.26562 6.89842 11.1914 3.19529 18.9961C3.04676 19.3106 2.96973 19.6541 2.96973 20.002C2.96973 20.3498 3.04676 20.6933 3.19529 21.0078C6.89842 28.8086 12.4961 32.7344 20 32.7344C27.5078 32.7344 33.1015 28.8086 36.8047 21.0039C37.1055 20.3711 37.1055 19.6367 36.8047 18.9922ZM20 29.9219C13.6992 29.9219 9.08592 26.7266 5.83201 20C9.08592 13.2734 13.6992 10.0781 20 10.0781C26.3008 10.0781 30.914 13.2734 34.168 20C30.918 26.7266 26.3047 29.9219 20 29.9219ZM19.8437 13.125C16.0469 13.125 12.9687 16.2031 12.9687 20C12.9687 23.7969 16.0469 26.875 19.8437 26.875C23.6406 26.875 26.7187 23.7969 26.7187 20C26.7187 16.2031 23.6406 13.125 19.8437 13.125ZM19.8437 24.375C17.4258 24.375 15.4687 22.418 15.4687 20C15.4687 17.582 17.4258 15.625 19.8437 15.625C22.2617 15.625 24.2187 17.582 24.2187 20C24.2187 22.418 22.2617 24.375 19.8437 24.375Z",
    fill: "#412304"
  })));
};

export default __webpack_public_path__ + "static/media/eye.db236403.svg";
export { SvgEye as ReactComponent };